import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
} from 'react';

export type SetState<T> = Dispatch<SetStateAction<T>>;

// todo: These filters will be used in the next tickets
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FiltersContextData {}

export const FiltersContext = createContext<FiltersContextData>(
  {} as FiltersContextData,
);

export const useFilters = () => useContext(FiltersContext);

export function FiltersProvider({ children }: PropsWithChildren) {
  const contextValue = useMemo(() => ({}), []);

  return (
    <FiltersContext.Provider value={contextValue}>
      {children}
    </FiltersContext.Provider>
  );
}
